import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Table from "../../core/pagination/datatable";
import TooltipIcons from "../../core/common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../core/common/tooltip-content/collapes";
import CommonFooter from "../../core/common/footer/commonFooter";
import CommonDeleteModal from "../../core/common/modal/commonDeleteModal";
import { useGetUnitListQuery, useDeleteUnitMutation } from "../../core/redux/api/productApi";
import toast from "react-hot-toast";
import AddUnitModal from "./add-unit-modal";

export const Units = () => {
  const { data: unitData, isLoading, isError, refetch } = useGetUnitListQuery();
  const [deleteUnit] = useDeleteUnitMutation();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
   console.log("unitData", unitData);
  const [unitToDelete, setUnitToDelete] = useState(null);
    const handleDelete = async () => { 
       if (!unitToDelete) return;
       
       try {
         await deleteUnit(unitToDelete).unwrap();
         toast.success("Unit deleted successfully!");
         refetch();
       } catch (error) {
         toast.error(`Unable to delete Unit: ${error?.message || "Something went wrong"}`);
       } finally {
         setShowDeleteModal(false);
         setUnitToDelete(null);
       }
     };

  const columns = [
    {
      title: "Unit",
      dataIndex: "unitName",
      sorter: (a, b) => a.unitName.length - b.unitName.length,
    },
    {
      title: "Short Name",
      dataIndex: "shortName",
      sorter: (a, b) => (a.shortName || '').length - (b.shortName || '').length,
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link  className="p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
            onClick={(e) => {
               e.preventDefault();
              // setShowDeleteModal(true);
              setUnitToDelete(record?._id); 
            }}
            >
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error loading units</div>;
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4 className="fw-bold">Units</h4>
                <h6>Manage your units</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
              >
               <i className='ti ti-circle-plus me-1'></i> Add Unit
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set">
              </div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <Table 
                  rowKey="_id"
  columns={columns}
  dataSource={unitData || []}
  loading={isLoading}
          
          />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <CommonFooter />
      </div>
      <AddUnitModal/> 
      {/* Add Unit */}
   
      {/* /Add Unit */}
      {/* Edit Unit */}
  
      {/* /Edit Unit */}
      {
       <CommonDeleteModal handleDelete={handleDelete}/>
      }
     
    </>
  );
};
